




























import { Component, Vue, Prop } from 'vue-property-decorator';
import JobCorpsCenter from '@/classes/JobCorpsCenter';

@Component
export default class MaterialShipToCenter extends Vue {
    @Prop() public centerId!: number;
    @Prop() public attnUserId!: number;

    public get jobCorpsCenter(): JobCorpsCenter | undefined {
        const center: JobCorpsCenter | undefined = this.$store.getters.getJobCorpsCenterById(this.centerId);
        return center;
    }

    public getUserProfileName(id: number) {
        const user = this.$store.getters.getUserProfileById(id);
        if (user) {
        return user.getFullName();
        } else {
        return '';
        }
  }
}
